import { QuestionBase } from "src/app/core/components/dynamic-form/models/question-base";

export const uploadFormConfiguration: QuestionBase[] = [
  {
    key: "titolo",
    label: "Titolo",
    required: true,
    controlType: "textbox",
    placeholder: "Inserire titolo",
    size: "sm-6",
    type: "text",
  },
  {
    key: "provenienza",
    label: "Provenienza",
    placeholder: "Seleziona",
    options: [],
    size: "sm-6",
    required: true,
    controlType: "dropdown",
    type: "",
  },
  {
    key: "tipoDocumento",
    label: "Tipo",
    placeholder: "Seleziona",
    options: [],
    size: "sm-6",
    required: true,
    controlType: "dropdown",
    type: "",
  },
  {
    key: "dataRiferimento",
    label: "Data riferimento",
    required: true,
    controlType: "date",
    size: "sm-6",
    type: "text",
  }
];